<style lang="scss">
.book-visit-form {
  .visitor-bans {
    margin-bottom: 0;
    .card-body {
      padding: 0;
    }
  }
}
</style>

<template>
  <div>
    <div v-if="!loading">
      <book-visit-offsite-form v-if="bookingType === 'offsite'" :wing-enabled="prison.enable_wings"/>
      <book-intake-visit-form v-else-if="bookingType === 'intake'"/>
      <book-visit-form v-else :wing-enabled="prison.enable_wings"/>
    </div>
    <div v-else>
      <div class="col text-center mt-5">
        <span class="fas fa-spinner fa-spin" style="font-size: 2em;"></span>
      </div>
    </div>
  </div>
</template>

<script>
  import BookVisitForm from '@/components/bookVisit/BookVisitForm';
  import BookVisitOffsiteForm from '@/components/bookVisit/BookVisitOffsiteForm';
  import BookIntakeVisitForm from '@/components/bookVisit/BookIntakeVisitForm';
  import {mapState} from 'vuex';

  export default {
    components: {
      BookVisitForm,
      BookVisitOffsiteForm,
      BookIntakeVisitForm,
    },
    data() {
      return {
        loading: true,
        bookingType: this.$route.meta.bookingType || 'normal',
      };
    },
    computed: {
      ...mapState({
        user: state => state.auth.user,
        prison: state => state.prison.prison,
      }),
    },
    async mounted() {
      await this.$store.dispatch('prison/getPrison');
      await this.$store.dispatch('booking/getRestrictedDates');
      this.loading = false;
    },
    methods: {},
  };
</script>
